import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MenuService } from './menu.service';

@Injectable()
export class MenuStoreService {

    private readonly menuSubject = new BehaviorSubject<any[]>([]);
    readonly menu$ = this.menuSubject.asObservable();

    constructor( private _menuService: MenuService) {
        this.getMenu();
    }

    get menu(): any[] {
        return this.menuSubject.getValue();
    }

    set menu(val: any[]) {
        this.menuSubject.next(val);
    }

    async getMenu() {
        this.menu = await this._menuService.getMenu().toPromise();
    }



}
